import { look } from "../components/look";
import { ramp } from "../components/ramp";
import { config } from "../config";
import type { LookKey } from "../config/assetManifest";
import { k } from "../core/kaplay";
import { registerEntity } from "../core/registry";

const RAMP_Z = 2;

export function registerRamps() {
    for (const [type, cfg] of Object.entries(config.obstacles)) {
        if (cfg.kind !== "ramp") continue;
        const [w, h] = cfg.hitboxPx ?? [128, 64];
        registerEntity(type, (d) =>
            k.add([
                k.pos(d.x, d.y),
                look(type as LookKey, d.variant),
                k.area({ shape: new k.Rect(k.vec2(-w / 2, -h), w, h), isSensor: true }),
                k.layer("ground"),
                k.z(RAMP_Z),
                ramp(type, cfg),
                "ramp",
                "world",
            ]),
        );
    }
}
